import React, { useEffect, useState } from 'react'
import i18n from '../i18n/i18n';
import { i18nContext } from '../i18n/i18nContext';
import Box from '@mui/material/Box';
import { Header } from './Header';
import { Footer } from './Footer';
import { HomeTopMailConfirm } from '../Home/HomeTopMailConfirm';
import { Container } from '@mui/material';
import { useDisplayItem } from '../DataFetch/useDisplayItem';
import { HomeWork } from '../Home/HomeWork';

/**
 * 動的テキストContext
 * 動的テキストをi18nの文に挿入するためのオプションオブジェクトを格納する
 */
export const HeldTimesContext = React.createContext({})

/**
 * KAGU応募画面のRoot関数
 */
export function CompetitionRoot (): JSX.Element {

    const Roots = {
        HomeTopMailConfirm: <HomeTopMailConfirm/>,
        HomeWork: <HomeWork/>
    }

    /**
     * 表示言語情報
     * ja または en
     */
    const [lng, setLng] = useState<string>("ja");

    /**
     * 表示言語情報が変更された時に実行
     * 表示言語を変更する
     */
    useEffect(() => {
        i18n.changeLanguage(lng);
    }, [lng])

    /**
     * 表示言語を切り替える
     */
    function ChangeLng() {
        setLng(lng === "ja" ? "en" : "ja");
    }

    /**
     * 動的テキストを取得
     */
    const {displayItem, isLoadingDisplayItem} = useDisplayItem();

    /**
     * 動的テキストをi18nの文字列に挿入するためのオプションオブジェクト
     * 表示言語によって値が切り替わる
     */
    const heldTimesOption = {
        heldTimes: lng === "ja" ? displayItem?.held_times_jp : displayItem?.held_times_en
    }

    return (
        <>  
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                }}
            >      
                <i18nContext.Provider value={{lng, setLng, ChangeLng}}>
                    <HeldTimesContext.Provider value = {heldTimesOption}>
                        <Header/>
                        <Container component="main" maxWidth="md">
                            {/* ビルドしたい画面に応じて切り替える */}

                            {/* メールアドレス登録 */}
                            {!isLoadingDisplayItem && Roots.HomeTopMailConfirm}
                            
                            {/* 作品登録 */}
                            {/* {!isLoadingDisplayItem && Roots.HomeWork} */}
                        </Container>
                        <Footer/>
                    </HeldTimesContext.Provider>
                </i18nContext.Provider>
            </Box>
        </>
    )
}
